// 操作日志状态/动作中文化映射（后端存英文，前端统一转中文显示）
export const STATUS_TEXT_MAP = {
  pending: '待处理',
  processing: '处理中',
  resolved: '已解决',
  closed: '已关闭',
  completed: '已完成',
  awaiting_customer: '待客服处理',
  urgent: '紧急',
  normal: '一般重要',
  high: '高优先级',
  low: '低优先级',
};

export const ACTION_TEXT_MAP = {
  create: '创建工单',
  update: '更新工单',
  status_change: '状态变更',
  chat_add: '新增对话',
  action_record: '处理记录',
  reminder: '提醒',
  upload_file: '上传附件',
  translate: '翻译',
  backfill: '历史回填',
  priority_escalate: '优先级升级',
  priority_judge: '系统自动判级',
  back_to_pending: '手动流转回待跟进',
  customer_reply: '客服/销售回复',
  email_reply: '收到邮件回复',
  complete: '工单完成',
  complete_order: '工单完成',
  reopen: '重新打开工单',
  system: '系统操作',
};

// 把英文状态值映射为中文
export function statusText(status) {
  if (!status) return '';
  return STATUS_TEXT_MAP[status] || status;
}

// 把英文动作值映射为中文
export function actionText(action) {
  if (!action) return '';
  return ACTION_TEXT_MAP[action] || action;
}

// 日志字段名中文化（field_changed）
export const FIELD_TEXT_MAP = {
  status: '工单状态',
  core_issue: '核心问题/异常情况',
  actual_action: '实际操作',
  result_feedback: '结果反馈',
  handling_strategy: '处理思路',
  follow_up_plan: '跟进策略',
  customer_name: '客户',
  priority: '优先级',
  carrier: '承运商',
  carrier_platform: '承运商平台',
  pickup_location: '提货地址',
  delivery_location: '送货地址',
  consignee: '收货人',
  cargo_description: '货物描述',
  weight: '重量',
  dimensions: '尺寸',
  estimated_delivery: '预计送达',
  reminder_cycle: '提醒周期',
  custom_reminder_hours: '自定义提醒时长',
  business_type: '业务类型',
  issue_images: '问题截图',
  kewell_order_no: '科维斯订单号',
  kewell_track: '查询编码',
  original_amount: '原始金额',
  channel: '渠道',
  appeal_reason: '申诉原因',
  appeal_detail: '申诉详情',
  appeal_amount: '申诉金额',
  customer_owner: '客户归属',
  expected_result: '期望结果',
  channel_party: '渠道方',
  follow_strategy: '是否遵循系统策略',
  escalate_hours: '升级紧急时长',
  claim_type: '索赔类型',
  claim_amount: '索赔金额',
  claim_reason: '索赔原因',
  claim_detail: '索赔详情',
  contact_info: '联系信息',
  email: '邮件',
};

// 把英文字段名映射为中文
export function fieldText(field) {
  if (!field) return '';
  return FIELD_TEXT_MAP[field] || field;
}

// 日志 old_value/new_value 如果是英文状态，也转中文
export function logValueText(v) {
  if (v === null || v === undefined) return '';
  const s = String(v);
  return STATUS_TEXT_MAP[s] || s;
}
